<div class="row mt-3">
    <div class="col-lg-12 text-end"> 
      <button   (click)="EmployeeLogsShow()" class="btn  btn-sm mb-2 me-1" [disabled]="global.viewTabs"  data-bs-toggle="modal" data-bs-target="#EmpLogsinfoedit">
        Employee Year Logs
     </button>     
      <button   (click)="editWages('new',null)" class="btn  btn-sm mb-2 me-1" [disabled]="global.viewTabs"  data-bs-toggle="modal" data-bs-target="#Wagesinfoedit">
       Add Wages
    </button>

    </div>
  </div>
  <ejs-grid #Wagesgrid [dataSource]='employeeWagesdata |async'[allowResizing]='true'[pageSettings]='initialPage' [filterSettings]='filterSettings'
  [allowSorting]='true' allowPaging='true' [allowFiltering]='true' (dataStateChange)='dataStateChange($event)'
  (actionBegin)="onActionComplete($event)" class="mx-1" >
  <e-columns>
    <e-column minWidth= 100 headerText="Actions" uid="action" textAlign='center'>
      <ng-template #template let-data>
        <button class="btn btn-edit-table mr-2"  [disabled]="global.viewTabs" (click)="editWages('edit',data)"  *ngIf="fp.payrateupdate"
        data-bs-toggle="modal" data-bs-target="#Wagesinfoedit"
        ><i 
            class="fa fa-edit"></i></button>
            <button  [disabled]="global.viewTabs"
            class=" btn btn-delete-table ms-2 " data-bs-toggle="modal" data-bs-target="#deletemodal"  (click)="setDeleteId(data.id)"  *ngIf="fp.payratedelete">
            <i class="fa fa-trash fa-lg"></i></button>
      </ng-template>
    </e-column>
  
    <e-column minWidth= 100 field="employeeName" headerText="Name" type="string">
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column minWidth= 100 field="empWageYear" headerText="Month and Year" type="date" [format]='formatOptionsYear'>
     
    </e-column>
    <e-column minWidth= 100 field="monthWages" headerText="Employee Wages" type="number"> 
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
   
   
  </e-columns>
  </ejs-grid>

  <span id="openDelete" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
  <div class="modal hide fade modalbackgrod" id="deletemodal" 
  tabindex="-1" role="dialog" aria-labelledby="deletewagesmodalLabel"
aria-hidden="true" data-bs-backdrop="false" >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
        </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"(click)="Delete()" >Delete</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>



  <span id="wagesmodelopen" data-bs-target="#Wagesinfoedit" data-bs-toggle="modal"></span>


<div class="modal hide fade modalbackgrod" id="Wagesinfoedit" tabindex="-1" role="dialog" aria-labelledby="wagesdropdownmodalLabel"
aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"  *ngIf="edittype == 'edit'">UpdatePayor Info</h5>
              
                <h5 class="modal-title font-header"  *ngIf="edittype == 'new'"> New Wages Info</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span> </button>
            </div>
            <div class="modal-body">             
                <div class="row">
                    <div class="col-lg-4">
                        <label class="label-bold">Choose Month and year<sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <div class="input-group">
                        <input type="text" id="BCRDate" [(ngModel)]="EmployeeWages.empWagDate" autocomplete="off"  [disabled]="edittype == 'edit'"
                        class="form-control" name="date" bsDatepicker [bsConfig]="datePickerConfig"
                        (onShown)="onOpenCalendar($event)" (ngModelChange)="getMonthYear($event)"
                        placeholder="yyyy-mm">
                    </div>
                    </div>               
                </div>        

                          
                <div class="row">
                    <div class="col-lg-4">
                        <label class="label-bold">Amount $<sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <input type="number" class="form-control"  [(ngModel)]="EmployeeWages.amount" >                       
                    </div>
                </div>             
              
            </div>    

            <div class="modal-footer">
                <button class="btn blue-btn" style="text-transform:none"  *ngIf="edittype == 'new'"  (click)="saveEmployeeWages(EmployeeWages);" 
            [disabled]="EmployeeWages.amount == null || EmployeeWages.amount == undefined || EmployeeWages.empWagDate==null || EmployeeWages.empWagDate== undefined"    >
                    Save & Close
                </button>
                <button class="btn blue-btn" style="text-transform:none" *ngIf="edittype == 'edit'"
                (click)="saveEmployeeWages(EmployeeWages);"  
                [disabled]="EmployeeWages.amount == null || EmployeeWages.amount == undefined || EmployeeWages.empWagDate==null || EmployeeWages.empWagDate== undefined" 
                >
                    Update & Close
                </button>&nbsp;
                <button type="button" class="btn blue-btn"  data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>




<span id="employeelogsmodelopen" data-bs-target="#EmpLogsinfoedit" data-bs-toggle="modal"></span>


<div class="modal hide fade modalbackgrod" id="EmpLogsinfoedit" tabindex="-1" role="dialog" aria-labelledby="EmpLogsmodalLabel"
aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" >Employee Yearly Wages Logs</h5>
              
             
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span> </button>
            </div>
            <div class="modal-body"> 
              <div class="row mb-2">
                <div class="col-lg-2">
                  <label for="year" class="selectYear_css">Select Year:</label>             

                </div>
                <div class="col-lg-3">
                  <ng-select [(ngModel)]="selectedYear" [items]="years"  (ngModelChange)="onYearChange(selectedYear)" bindLabel="year" placeholder="Select Year" [clearable]="false">
                  </ng-select>
                </div>

              </div>            
                <div class="row">
                    <div class="col-lg-12">
                      <ejs-grid #EmpLogsgrid [dataSource]='employeeLogsData |async'[allowResizing]='true'[pageSettings]='initialPage' [filterSettings]='filterSettings'
                      [allowSorting]='true' allowPaging='true' [allowFiltering]='true' (dataStateChange)='LogsdataStateChang1e($event)'  [height]='500'
                      (actionBegin)="LogsOnActionComplete($event)" class="mx-1" >
                      <e-columns>
                        
                        <e-column Width="100" field="employeeName" headerText="Name" [allowFiltering]='false' [allowSorting]='false'>
                          
                        </e-column>
                        <e-column Width="100" field="serviceName"  headerText="Service">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column Width="100" field="logType" headerText="Log Type" type="string" >
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>

                        <e-column Width="100" field="timeSheetDate" headerText="Date" type="date" [format]='formatOptionsDate'></e-column>

                        <e-column Width="100" field="totalWages"  headerText="Total Wages">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column Width="150" field="timesheetTotalAmount"  headerText="Total Amount">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column Width="150" field="empWageYear" headerText="EmpWageYear" type="date" [allowFiltering]='false' [format]='formatOptionsYearonly'>
                        </e-column>
                        <e-column Width="220" field="createdTime" headerText="Created Time" type="date"  [allowFiltering]='false' [allowSorting]='false' [format]='formatOptionsYear'>
                        </e-column>
                       
                        
                      </e-columns>
                      </ejs-grid>
                    </div>            
                </div>        

                          
                          
              
            </div>    

            <div class="modal-footer">
                
                <button type="button" class="btn blue-btn"  data-bs-dismiss="modal" >Close</button>
            </div>
        </div>
    </div>
</div>


<!-- <ngx-ui-loader [fgsTemplate]="foregroundSpinner" [bgsTemplate]="foregroundSpinner" bgsSize="100" fgsSize="100">
</ngx-ui-loader>
<ng-template #foregroundSpinner>
    <div class="ball-clip-rotate-shapes-rotate">
        <div></div>
        <div></div>

    </div>

</ng-template> -->


  
  